<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <md-button
          class="md-icon-button toggle-button"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <md-icon>{{ $sidebar.showSidebar ? 'arrow_back_ios' : 'arrow_forward_ios' }}</md-icon>
        </md-button>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-simple"
          @click="logout"
        >
          Logout
        </md-button>
      </div>
    </div>
  </md-toolbar>
</template>
<script>
export default {
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    logout() {
      localStorage.removeItem("jwt");

      if(localStorage.getItem("jwt") == null){
          this.$router.push("/sign-in");
      }
    }
  }
};
</script>
<style lang="css" scoped>
    .toggle-button {
        padding: 5px;
        border-radius: 3px;
    }
</style>
